import decode from 'jwt-decode'
import { destroyCookie, setCookie, parseCookies } from 'nookies'
import { GetServerSidePropsContext } from 'next'

export const TOKEN_NAME = 'infoslar.token'
const REFRESH_TOKEN = 'infoslar.refreshtoken'

export function setTokenCookie(token: string) {
  setCookie(undefined, TOKEN_NAME, token)
}

export function removeToken(ctx?: GetServerSidePropsContext) {
  destroyCookie(ctx, TOKEN_NAME)
}

export function removeRefreshToken(ctx?: GetServerSidePropsContext) {
  destroyCookie(ctx, REFRESH_TOKEN)
}

export function getTokenCookie(ctx?: GetServerSidePropsContext) {
  const cookies = parseCookies(ctx)
  return cookies[TOKEN_NAME]
}

export function setRefreshTokenCookie(token: string) {
  setCookie(undefined, REFRESH_TOKEN, token)
}

export function getRefreshToken(ctx?: GetServerSidePropsContext) {
  const cookies = parseCookies(ctx)
  return cookies[REFRESH_TOKEN]
}

export function isAuthenticated(ctx?: GetServerSidePropsContext) {
  return Boolean(getTokenCookie(ctx))
}

export interface DecodedToken {
  user_id?: number
  user_name?: string
  company_id?: number
  company_slug?: string
  exp?: number
}

export function getTokenDecoded(ctx?: GetServerSidePropsContext): DecodedToken {
  try {
    return decode<DecodedToken>(getTokenCookie(ctx))
  } catch (error) {
    return {}
  }
}
